export default __webpack_public_path__ + "static/media/2.42dae83a.JPG";